module.exports = __webpack_public_path__ + "static/media/2.787ee6af.svg";